// src/pages/Customers/components/WishlistTab.tsx
import React from "react";
import {useGetUserFavoritesQuery} from "../../../store/api/favoriteApi";
import {DataTable} from "../../../components/common";
import type {DataTableColumn} from "../../../components/common/DataTable/DataTableTypes";
import type {FavoriteResponseDto} from "../../../types/favorite";
import {format} from "date-fns";

interface WishlistTabProps {
  customerId: number;
}

const WishlistTab: React.FC<WishlistTabProps> = ({customerId}) => {
  const {data, isLoading, isError} = useGetUserFavoritesQuery({
    userId: customerId,
  });

  const columns: DataTableColumn<FavoriteResponseDto>[] = [
    {
      key: "propertyTitle",
      title: "Property Title",
      render: (_value, record) => record.property?.titleMm || "N/A",
    },
    {
      key: "addedOn",
      title: "Added On",
      render: (_value, record) => format(new Date(record.createdAt), "PPP"),
    },
  ];

  if (isLoading) {
    return <div>Loading wishlist...</div>;
  }

  if (isError) {
    return <div>Error loading wishlist.</div>;
  }

  if (!data || data.data.length === 0) {
    return <div>No wishlist items found for this customer.</div>;
  }

  return (
    <div>
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
        Customer Wishlist
      </h3>
      <DataTable<FavoriteResponseDto>
        data={data.data}
        columns={columns}
        rowKey="id"
        // You might want to add pagination, sorting, and filtering here if needed
      />
    </div>
  );
};

export default WishlistTab;
